/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { PostStatsResponseType, StatsRecord } from "~/features/dashboard/types";

const transformToStats = (apiData: PostStatsResponseType): Record<string, StatsRecord[]> => {
  const transformed: Record<string, StatsRecord[]> = {};

  apiData.data.body.forEach((site) => {
    site.details.forEach((detail) => {
      if (!transformed[detail.tm]) {
        transformed[detail.tm] = [];
      }
      transformed[detail.tm].push({
        date: detail.tm,
        netRevenue: Number(detail.netrevenue),
        grossRevenue: Number(detail.trstamntsuc),
        premiumJoins: Number(detail.prejns),
        nonPremiumJoins: Number(detail.nonprejns),
        newPayingUsers: Number(detail.newchrgusr),
        logins: Number(detail.uniquelogins),
        clicks: Number(detail.clicks),
        domain: detail.sitedomain,
      });
    });
  });
  return transformed;
};

export default transformToStats;
